export const getPathId = (location: any) => location.pathname.slice(1).replace('#/', '');
